// import { PrimeNGConfig } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PageTitleService } from './services/page-title.service';
import { NotificationInitService } from './services/notification-init.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private pageTitleService: PageTitleService,  // Injected to activate page title updates
    private notificationInitService: NotificationInitService
    // private primengConfig: PrimeNGConfig
  ) {
    this.translate.addLangs(['ar', 'en']);
    this.translate.setDefaultLang('ar');

    // this.primengConfig.ripple = true;
  }
  title = 'rwiqha-seller';
  currentLang!: string;

  ngOnInit() {
    this.translate.setDefaultLang('ar');
    this.translate.use('ar');
    this.currentLang = localStorage.getItem('language') || this.translate.getDefaultLang() || 'en';
    this.switchLanguage(this.currentLang);

    // Initialize notification system after language setup
    this.notificationInitService.initialize();
  }

  switchLanguage(language: string) {
    this.currentLang = language;
    this.translate.use(language);
    this.translate.setDefaultLang(language);
    localStorage.setItem('language', language);
    const html: HTMLHtmlElement = document.getElementsByTagName('html')[0];
    if (html) {
      const langDir = language === 'ar' ? 'rtl' : 'ltr';
      html.classList.remove('rtl', 'ltr');
      html.dir = langDir;
      html.classList.add(langDir);
    }
  }
}
